/**
 * Navigation toggle
 */
document.addEventListener('DOMContentLoaded', function () {
    const navToggle = document.getElementById('btn-nav-toggle');
    const body = document.body;
    const html = document.documentElement;
    const bodyOverlay = document.querySelector('.body-overlay'); // Select the overlay

    if (!navToggle || !bodyOverlay) return;

    function closeMenu() {
        body.classList.remove('has-nav-open');
        body.classList.add('has-nav-closed');
        navToggle.classList.remove('is-active');
        navToggle.setAttribute('aria-expanded', 'false');
        html.style.overflow = ''; // Restore scrolling
    }

    navToggle.addEventListener('click', function () {
        const hasNavOpen = body.classList.contains('has-nav-open');

        body.classList.toggle('has-nav-open', !hasNavOpen);
        body.classList.toggle('has-nav-closed', hasNavOpen);
        this.toggleAttribute('aria-expanded', !hasNavOpen);

        html.style.overflow = hasNavOpen ? '' : 'hidden'; // Manage page scrolling
    });

    // Close menu when clicking on overlay
    bodyOverlay.addEventListener('click', closeMenu);
});


/**
 * Submenu toggle
 */
document.querySelectorAll('.submenu-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
        const parent = this.parentElement;
        if (parent.classList.contains('dropdown-active')) {
            parent.classList.toggle('dropdown-active');
        } else {
            parent.classList.toggle('dropdown-active');
            var siblings = parent.parentElement.children;
            Array.prototype.forEach.call(siblings, function (sibling) {
                if (sibling !== parent) {
                    sibling.classList.remove('dropdown-active');
                }
            });
        }
    });
});


/**
 * Select all <li> elements that have the class "is-dropdown-submenu-parent" inside a <nav> with a <ul>
 */
document.querySelectorAll('nav ul > li.is-dropdown-submenu-parent').forEach(function (item) {
    item.addEventListener('mouseover', function () {
        document.body.classList.remove('dropdown-closed');
        document.body.classList.add('dropdown-open');
    });

    item.addEventListener('mouseleave', function () {
        document.body.classList.remove('dropdown-open');
        document.body.classList.add('dropdown-closed');
    });
});
